import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  align-items: center;
`;

export default Row;
